// extracted by mini-css-extract-plugin
export default {"button":"Button_button__OOMYT","orange":"Button_orange__xm8NN","blue":"Button_blue__V1tHc","red":"Button_red__8OU8I"};